<script>
export default {
  name: "smartReview",
  data() {
    return {
      enabled: false,
      defaultProofEmailTemplateId: null,
      defaultNewVersionEmailTemplateId: null,
      working: false,
    };
  },
  async mounted() {
    // Fetch fresh: sessions created before this feature deployed lack the new
    // account field. The template ids must ride along on save or the update
    // endpoint clears them (same caveat as the contact portal toggle).
    const account = await this.$A.AccountService.Get();
    this.enabled = _.get(account, "smartReviewEnabled", false);
    this.defaultProofEmailTemplateId = _.get(account, "defaultProofEmailTemplateId", null);
    this.defaultNewVersionEmailTemplateId = _.get(account, "defaultNewVersionEmailTemplateId", null);
  },
  methods: {
    async toggleChanged() {
      if (this.working) return;
      this.working = true;
      const account = await this.$A.AccountService.SetSmartReviewEnabled(
        this.enabled,
        this.defaultProofEmailTemplateId,
        this.defaultNewVersionEmailTemplateId
      );
      this.working = false;
      if (account) {
        this.enabled = _.get(account, "smartReviewEnabled", this.enabled);
        _.set(this.$A, "Auth.account.smartReviewEnabled", this.enabled);
        this.$A.SaveSessionData(this.$A.Auth);
      }
    },
  },
};
</script>

<template>
  <div class="settings-card">
    <div class="card-head">
      <div class="card-head-title">
        Smart Review <span class="beta-pill">Beta</span>
      </div>
      <div class="card-head-subtitle">
        Highlights what changed between proof versions, so you and your approvers approve faster.
      </div>
    </div>
    <div class="card-body">
      <div class="ashore-toggle smart-review-toggle-row">
        <label class="switch">
          <input type="checkbox" v-model="enabled" @change="toggleChanged" />
          <span class="slider round"></span>
        </label>
        Enable Smart Review
      </div>
      <ul class="smart-review-benefits">
        <li>
          <img src="/img/check-circle.svg" alt="" class="benefit-check" />
          Changed text, images, and moved elements marked right on the proof
        </li>
        <li>
          <img src="/img/check-circle.svg" alt="" class="benefit-check" />
          A version-to-version list of every change, with no manual side-by-side
        </li>
        <li>
          <img src="/img/check-circle.svg" alt="" class="benefit-check" />
          Approvers focus on what's new and approve faster, with confidence
        </li>
      </ul>
    </div>
  </div>
</template>

<style scoped>
.settings-card {
  background: #fff;
  border: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(8, 11, 13, 0.04), 0 8px 24px -16px rgba(8, 11, 13, 0.1);
}
.card-head {
  padding: 14px 20px;
  background: #fbfbfc;
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 12px 12px 0 0;
}
.card-head-title {
  font-weight: 600;
  color: #111827;
}
.beta-pill {
  display: inline-block;
  margin-left: 6px;
  padding: 1px 7px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #019255;
  background: rgba(1, 146, 85, 0.12);
  border-radius: 10px;
  vertical-align: middle;
}
.card-head-subtitle {
  max-width: 640px;
  font-size: 13px;
  line-height: 1.5;
  color: #6b7280;
}
.card-body {
  padding: 20px;
}
.smart-review-toggle-row {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  font-weight: 500;
  color: #374151;
}
.smart-review-benefits {
  margin: 16px 0 0;
  padding: 16px 0 0;
  border-top: 1px solid rgba(15, 23, 42, 0.06);
  list-style: none;
}
.smart-review-benefits li {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 4px 0;
  max-width: 640px;
  font-size: 13px;
  color: #6b7280;
}
.benefit-check {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  margin-top: 2px;
}
</style>
